import { SettingsPreviewNotice } from './SettingsPrimitives';

const STATUS_COPY = {
  loading: {
    title: '正在带回你的习惯',
    body: '稍等一下，创作台马上就顺手了。',
  },
  ready: {
    title: '你的习惯已经就位',
    body: '接下来怎么调，都会跟着账号保存。',
  },
  saving: {
    title: '正在替你记住',
    body: '可以继续调整，我们会按顺序一起收好。',
  },
  saved: {
    title: '已经记住了',
    body: '下次登录，也会沿用这些习惯。',
  },
  conflict: {
    title: '另一台设备刚改过',
    body: '看看当前选择，确认后再保存一次就好。',
    actionLabel: '按当前选择保存',
  },
  error: {
    title: '这次没保存好',
    body: '你的当前选择还在，网络恢复后可以再试一次。',
    actionLabel: '重新保存',
  },
};

const STATUS_COPY_EN = {
  loading: { title: 'Bringing back your preferences', body: 'One moment—your workspace will feel familiar again.' },
  ready: { title: 'Your preferences are ready', body: 'New changes will be saved with your account.' },
  saving: { title: 'Saving your preferences', body: 'Keep adjusting—we will save each change in order.' },
  saved: { title: 'Preferences saved', body: 'They will be here the next time you sign in.' },
  conflict: { title: 'Changed on another device', body: 'Review the current choices, then save once more.', actionLabel: 'Save current choices' },
  error: STATUS_COPY.error,
};

export default function PreferenceSyncNotice({
  preview,
  status,
  onRetry,
  previewText,
  english = false,
}) {
  if (preview) {
    return (
      <SettingsPreviewNotice>
        {previewText || (english ? 'Adjust freely—these choices will not disrupt your current project.' : '放心调一调，当前选择不会打乱你正在创作的项目。')}
      </SettingsPreviewNotice>
    );
  }

  const source = english && !['error', 'conflict'].includes(status) ? STATUS_COPY_EN : STATUS_COPY;
  const copy = source[status] || source.ready;
  return (
    <SettingsPreviewNotice
      title={copy.title}
      actionLabel={copy.actionLabel}
      onAction={copy.actionLabel ? onRetry : undefined}
    >
      {copy.body}
    </SettingsPreviewNotice>
  );
}
